// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"styles_loader_wrapper__xuJSy","loading":"styles_loading__hKQAx"};